<div class="mt-2">
  <div class="row">
    <div class="col-md-10 mt-4 w-100">
      <h4 class="title"><i class="fas fa-wallet"></i> {{title | translate}}</h4>
    </div>
  </div>
</div>
<div class="widget-box widget-plain mt-1">
  <div class="center">
    <ul class="stat-boxes pl-5">
      <li class="card" *ngFor="let generalQuantity of generalQuantities">
        <div class="right">
          <app-consolidated-cards-report [generalQuantity]="generalQuantity"></app-consolidated-cards-report>
        </div>
      </li>
    </ul>
  </div>
</div>
<div class="row mt-2">
  <div class="col-md-2 custom-mr-24" *ngIf="hasRole(ROLE_SUPERADMIN)">
    <label class=" font-weight-bold">{{ "LABEL.PARTNER" | translate }}: </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-university"></i></div>
      </div>
      <select *ngIf="hasRole(ROLE_SUPERADMIN)"
              class="form-control"
              [(ngModel)]="partnerSelected"
              (ngModelChange)="reloadEnterprises()">
        <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name | translate}}</option>
      </select>
    </div>
  </div>
  <div class="col-md-2 custom-mr-24" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
    <label class="font-weight-bold">{{ "LABEL.ENTERPRISE" | translate }}: </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-building"></i></div>
      </div>
      <select class="form-control"
              [(ngModel)]="enterpriseSelected"
              (ngModelChange)="reloadWorkflows()">
        <option *ngFor="let enterprise of enterprises" [ngValue]="enterprise">{{enterprise.name | translate}}</option>
      </select>
    </div>
  </div>
  <div class="col-md-2 custom-mr-24" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER) || hasRole(ROLE_ADMIN)">
    <label class="font-weight-bold">{{ "LABEL.FLOW" | translate }}: </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-code-branch"></i></div>
      </div>
      <select class="form-control"
              [(ngModel)]="workflowSelected"
              (ngModelChange)="search()">
        <option *ngFor="let workflow of workflows" [ngValue]="workflow">{{workflow.description | translate}}</option>
      </select>
    </div>
  </div>
  <div class="col-md-2 custom-mr-24">
    <label for="dateFrom" class="font-weight-bold" data-toggle="tooltip"
           title="{{ 'MESSAGE.MAXIMUM-RANGE-IS-3-MONTHS' | translate }}">{{ "LABEL.FROM" | translate }}: </label>
    <div class="input-group w-custom-100">
      <input id="dateFrom" #dpFromDate
             class="form-control {{hasNotCorrectDateRange() ? 'border-color-red' : ''}}"
             name="dpFromDate"
             (dateSelect)="onDateSelectionFrom($event)"
             [value]="formatter.format(fromDate)"
             (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
             ngbDatepicker #d="ngbDatepicker"
             [markDisabled]="validatedDateFrom"
             [startDate]="fromDate"
             placeholder="dd/mm/yyyy" style="width: 150px;">
      <span class="custom-day"></span>
      <div class="input-group-append" [ngbTooltip]="info">
        <span class="btn btn-outline-success p-fixed {{hasNotCorrectDateRange() ? 'border-color-red' : ''}}"
                (click)="d.toggle()" type="button">
          <i class="far fa-calendar-alt"></i>
        </span>
      </div>
    </div>
  </div>
  <div class="col-md-2 custom-mr-24">
    <label for="dateTo"
           class="font-weight-bold pl-1" data-toggle="tooltip"
           title="La fecha 'hasta' es calculada en el rango de 3 meses apartir de la fecha 'desde'.">
      {{ "LABEL.TO" | translate }}:</label>
    <div class="input-group w-custom-100">
      <input id="dateTo" #dpToDate
             class="form-control  {{hasNotCorrectDateRange() ? 'border-color-red' : ''}}"
             name="dpToDate"
             (dateSelect)="onDateSelectionTo($event)"
             [value]="formatter.format(toDate)"
             (input)="toDate = validateInput(toDate, dpToDate.value)"
             ngbDatepicker #d1="ngbDatepicker"
             [markDisabled]="validatedDateTo"
             placeholder="dd/mm/yyyy" style="width: 150px;">
      <div class="input-group-append" [ngbTooltip]="info">
        <span class="btn btn-outline-success p-fixed {{hasNotCorrectDateRange() ? 'border-color-red' : ''}}"
                (click)="d1.toggle()" type="button">
          <i class="far fa-calendar-alt"></i>
        </span>
      </div>
    </div>
  </div>
  <div class="col-md-1 custom-mt-24">
    <button type="button"
            class="btn btn-outline-success btn-width-100 custom-button"
            data-toggle="tooltip"
            title="{{ 'MESSAGE.MAXIMUM-RANGE-IS-3-MONTHS' | translate }}"
            [disabled]="hasNotCorrectDateRange()"
            (click)="search()">
      <i class="fa fa-search"></i> {{ "BUTTON.SEARCH" | translate }}
    </button>
  </div>
  <div class="col-md-1 custom-mt-24">
    <button type="button"
            class="btn btn-secondary dxbs-button w-custom-100"
            (click)="downloadReportOf()">
      <span aria-hidden="true" class="image far fa-file-excel"></span>
      {{ "BUTTON.EXPORT" | translate }}
    </button>
  </div>
</div>
<div class="table-responsive mt-2 mb-2 custom-table-height">
  <table class="table-sm table-bordered">
    <thead>
    <tr>
      <th scope="col" title="#"></th>
      <th scope="col" *ngIf="getVisibilityColumnPartner()">{{ "TABLE.HEADER.PARTNER" | translate }}</th>
      <th scope="col" *ngIf="getVisibilityColumnEnterprise()">{{ "TABLE.HEADER.ENTERPRISE" | translate }}</th>
      <th scope="col" *ngIf="getVisibilityColumnWorkflow()">{{ "TABLE.HEADER.FLOW" | translate }}</th>
      <th scope="col">{{ "TABLE.HEADER.GRAPHIC-S" | translate }}</th>
      <th scope="col">{{ "TABLE.HEADER.DIGITAL-S" | translate }}</th>
      <th scope="col">{{ "TABLE.HEADER.ONE-SIGN-S" | translate }}</th>
      <th scope="col">{{ "TABLE.HEADER.REMOTE-S" | translate }}</th>
      <th scope="col">{{ "TABLE.HEADER.REMOTE-WITH-TIMESTAMP-S" | translate }}</th>
      <th scope="col">{{ "TABLE.HEADER.REMOTE-LTV-S" | translate }}</th>
      <th scope="col">{{ "TABLE.HEADER.REVISIONS" | translate }}</th>
      <th scope="col">{{ "TABLE.HEADER.TIMESTAMP" | translate }}</th>
      <th scope="col">{{ "TABLE.HEADER.ELECT-NOTI" | translate }}</th>
      <th scope="col">{{ "TABLE.HEADER.SENDING-CE" | translate }}</th>
      <th scope="col">{{ "TABLE.HEADER.NOTCER" | translate }}</th>
      <th scope="col">{{ "TABLE.HEADER.IOF-CONSUMED" | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let iofConsolidate of iofConsolidates; let index=index"
        class="{{hasRole(ROLE_PARTNER)?'custom-font-size-table-body':'custom-font-size-table-body-isnt-partner'}}">
      <td title="#">{{(page.number * pageNumber) + index + 1}}</td>
      <td title="partner" *ngIf="getVisibilityColumnPartner()">{{iofConsolidate.partnerName}}</td>
      <td title="enterpriseName" *ngIf="getVisibilityColumnEnterprise()">{{iofConsolidate.enterpriseName}}</td>
      <td title="workflow" *ngIf="getVisibilityColumnWorkflow()">{{iofConsolidate.workflowName}}</td>
      <td title="{{ 'TABLE.HEADER.GRAPHIC-S' | translate }}"><a
        *ngIf="!hasMoreThanZero(iofConsolidate.quantityGraphicSignature)">-</a>
        <span *ngIf="hasMoreThanZero(iofConsolidate.quantityGraphicSignature)"
              class="badge badge-info"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{iofConsolidate.quantityGraphicSignature}}"
              (click)="viewDetail(iofConsolidate, ELECTRONIC_SIGNATURE)">{{iofConsolidate.quantityGraphicSignature}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.DIGITAL-S' | translate }}"><a
        *ngIf="!hasMoreThanZero(iofConsolidate.quantityDigitalSignature)">-</a>
        <span *ngIf="hasMoreThanZero(iofConsolidate.quantityDigitalSignature)"
              class="badge badge-info"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{iofConsolidate.quantityDigitalSignature}}"
              (click)="viewDetail(iofConsolidate, DIGITAL_SIGNATURE)">{{iofConsolidate.quantityDigitalSignature}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.ONE-SIGN-S' | translate }}"><a
        *ngIf="!hasMoreThanZero(iofConsolidate.quantityOneSignSignature)">-</a>
        <span *ngIf="hasMoreThanZero(iofConsolidate.quantityOneSignSignature)"
              class="badge badge-info"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{iofConsolidate.quantityOneSignSignature}}"
              (click)="viewDetail(iofConsolidate, CLOUD_SIGNATURE)">{{iofConsolidate.quantityOneSignSignature}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.REMOTE-S' | translate }}"><a
        *ngIf="!hasMoreThanZero(iofConsolidate.quantityRemoteSignature)">-</a>
        <span *ngIf="hasMoreThanZero(iofConsolidate.quantityRemoteSignature)"
              class="badge badge-info"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{iofConsolidate.quantityRemoteSignature}}"
              (click)="viewDetail(iofConsolidate, REMOTE_SIGNATURE)">{{iofConsolidate.quantityRemoteSignature}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.REMOTE-WITH-TIMESTAMP-S' | translate }}"><a
        *ngIf="!hasMoreThanZero(iofConsolidate.quantityRemoteSignatureWithTimeStamp)">-</a>
        <span *ngIf="hasMoreThanZero(iofConsolidate.quantityRemoteSignatureWithTimeStamp)"
              class="badge badge-info"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{iofConsolidate.quantityRemoteSignatureWithTimeStamp}}"
              (click)="viewDetail(iofConsolidate, REMOTE_SIGNATURE_WITH_TIMESTAMP)">{{iofConsolidate.quantityRemoteSignatureWithTimeStamp}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.REMOTE-LTV-S' | translate }}"><a
        *ngIf="!hasMoreThanZero(iofConsolidate.quantityRemoteSignatureWithLTV)">-</a>
        <span *ngIf="hasMoreThanZero(iofConsolidate.quantityRemoteSignatureWithLTV)"
              class="badge badge-info"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{iofConsolidate.quantityRemoteSignatureWithLTV}}"
              (click)="viewDetail(iofConsolidate, REMOTE_SIGNATURE_WITH_LTV)">{{iofConsolidate.quantityRemoteSignatureWithLTV}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.REVISIONS' | translate }}"><a *ngIf="!hasMoreThanZero(iofConsolidate.quantityReview)">-</a>
        <span *ngIf="hasMoreThanZero(iofConsolidate.quantityReview)"
              class="badge badge-info"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{iofConsolidate.quantityReview}}"
              (click)="viewDetail(iofConsolidate, REVIEW)">{{iofConsolidate.quantityReview}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.TIMESTAMP' | translate }}"><a *ngIf="!hasMoreThanZero(iofConsolidate.quantityTimeStamp)">-</a>
        <span *ngIf="hasMoreThanZero(iofConsolidate.quantityTimeStamp)"
              class="badge badge-info"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{iofConsolidate.quantityTimeStamp}}"
              (click)="viewDetail(iofConsolidate, TIMESTAMP)">{{iofConsolidate.quantityTimeStamp}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.ELECT-NOTI' | translate }}"><a
        *ngIf="!hasMoreThanZero(iofConsolidate.quantitySendElectronicNotification)">-</a>
        <span *ngIf="hasMoreThanZero(iofConsolidate.quantitySendElectronicNotification)"
              class="badge badge-info"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{iofConsolidate.quantitySendElectronicNotification}}"
              (click)="viewDetail(iofConsolidate, SEND_ELECTRONIC_NOTIFICATION)">{{iofConsolidate.quantitySendElectronicNotification}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.SENDING-CE' | translate }}"><a *ngIf="!hasMoreThanZero(iofConsolidate.quantitySendEmail)">-</a>
        <span *ngIf="hasMoreThanZero(iofConsolidate.quantitySendEmail)"
              class="badge badge-info"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{iofConsolidate.quantitySendEmail}}"
              (click)="viewDetail(iofConsolidate, SEND_EMAIL)">{{iofConsolidate.quantitySendEmail}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.NOTCER' | translate }}"><a *ngIf="!hasMoreThanZero(iofConsolidate.quantityNotcer)">-</a>
        <span *ngIf="hasMoreThanZero(iofConsolidate.quantityNotcer)"
              class="badge badge-info"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{iofConsolidate.quantityNotcer}}"
              (click)="viewDetail(iofConsolidate, NOTCER)">{{iofConsolidate.quantityNotcer}}</span>
      </td>

      <td title="{{ 'TABLE.HEADER.IOF-CONSUMED' | translate }}"><a *ngIf="!hasMoreThanZero(iofConsolidate.consumed)">-</a>
        <span *ngIf="hasMoreThanZero(iofConsolidate.consumed)"
              class="badge badge-danger"
              data-toggle="tooltip"
              data-placement="bottom"
              title="-{{iofConsolidate.consumed.toFixed(4)}}">-{{iofConsolidate.consumed.toFixed(4)}}</span>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<nav class="Page navigation pagination-custom">
  <div class="row">
    <div class="col-md-8 mt-1">
      <div class="justify-content-row">
        <label class="mr-1 font-weight-normal">Mostrar </label>
        <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                (ngModelChange)="loadConsolidatedServices(enumPage.First)">
          <option *ngFor="let page of pageNumbers" [value]="page.value"
                  class="font-weight-bold">{{page.value}}</option>
        </select>
        <label class="font-weight-normal"> registros.</label>
      </div>
      <div class="page-total-entries">
        {{ "LABEL.TOTAL-RECORDS" | translate }}
        : {{iofConsolidates.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
      </div>
    </div>
    <div class="col-md-4">
      <ul class="pagination justify-content-end text-center">
        <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
          <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadConsolidatedServices(enumPage.First)"
             tabindex="-1" aria-disabled="true">
            <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
            {{ "BUTTON.FIRST" | translate }}
          </a>
        </li>
        <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
          <a class="left {{page.number == 0 ? 'disabled' : ''}}"
             (click)="loadConsolidatedServices(enumPage.Previous)">
            <i class="fa fa-angle-left" aria-hidden="true"></i></a>
        </li>
        <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
          <a class="right" (click)="loadConsolidatedServices(enumPage.Next)"><i
            class="fa fa-angle-right" aria-hidden="true"></i></a>
        </li>
        <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
          <a class="next" (click)="loadConsolidatedServices(enumPage.Last)">
            {{ "BUTTON.LAST" | translate }}
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<app-loading *ngIf="(loading && !calledOfAutorefresh) || loadingShowBy"></app-loading>
<ng-template #info>{{ "MESSAGE.MAXIMUM-RANGE-IS-3-MONTHS" | translate }}</ng-template>
